import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";

import { get } from "../helpers/HTTP";
import getQueryKeys from "./getQueryKeys";

import type { RecentLead } from "../types";

async function getRecentLeads(
  workspaceId: string,
  campaignId: string,
  flowId: string,
  accountIds: string[],
): Promise<RecentLead[]> {
  const searchParams = new URLSearchParams();

  if (campaignId) {
    searchParams.append("campaign_id", campaignId);
  }

  if (flowId) {
    searchParams.append("flow_id", flowId);
  }

  if (accountIds.length) {
    searchParams.append("account_ids", JSON.stringify(accountIds));
  }

  return (
    await get(
      `workspaces/${workspaceId}/analytics/recent-leads?${searchParams.toString()}`,
    )
  ).leads;
}
export default function useRecentLeads({
  flowId,
  campaignId,
  accountIds,
}: {
  flowId: string;
  campaignId: string;
  accountIds: string[];
}) {
  const { id: workspaceId, accounts_count: accountsCount } =
    useSelectedWorkspaceContext();

  const { leadsKeys } = getQueryKeys(workspaceId);

  const {
    data: recentLeads,
    isLoading: isLoadingRecentLeads,
    error: recentLeadsError,
    refetch: refetchRecentLeads,
  } = useQuery({
    queryKey: leadsKeys.recent(accountIds, campaignId, flowId),
    queryFn: () => getRecentLeads(workspaceId, campaignId, flowId, accountIds),
    enabled: accountsCount > 0,
  });

  return {
    recentLeads,
    isLoadingRecentLeads,
    recentLeadsError,
    refetchRecentLeads,
  };
}
